import Vue from "vue";
import Vuex from "vuex";
import {
  ClientControllerApi,
  Configuration,
  ItemControllerApi,
  ItemRead,
  ItemWrite,
  LockerRead,
  OverviewDto,
  TypeRead
} from "@/swagger";

Vue.use(Vuex);

const conf = new Configuration({
  basePath: process.env.VUE_APP_API_URL
});

const itemApi = new ItemControllerApi(conf);
const clientApi = new ClientControllerApi(conf);

export default new Vuex.Store({
  state: {
    items: [] as OverviewDto[],
    history: [] as ItemRead[],
    selectedItems: [] as ItemRead[],
    item: {} as ItemRead,
    lockers: [] as LockerRead[],
    types: [] as TypeRead[],
    empty: {}
  },
  mutations: {
    replaceItems(state, items) {
      state.items = items;
    },
    setSelectedItem(state, items) {
      state.selectedItems = items;
    },
    setItem(state, item) {
      state.item = item;
    },
    setTypes(state, types) {
      state.types = types;
    },
    setLockers(state, lockers) {
      state.lockers = lockers;
    },
    setHisotry(state, history) {
      state.history = history;
    },
    doNothing(state, empty) {
      state.empty = empty;
    }
  },
  actions: {
    async overview({ commit }) {
      const data = await itemApi.getOverview();
      commit("replaceItems", data);
    },
    async overviewItem({ commit }, item) {
      const data = await itemApi.overviewItem(item.name, item.date);
      commit("setSelectedItem", data);
      return data;
    },
    async itemDetail({ commit }, item: { id: string }) {
      const data = await itemApi.getItemById(item.id);
      commit("setItem", data);
      return data;
    },
    async getTypes({ commit }) {
      const data = await clientApi.getTypes();
      commit("setTypes", data);
      return data;
    },
    async getLockers({ commit }) {
      const data = await clientApi.getLockers();
      commit("setLockers", data);
      return data;
    },
    async updateItem({ commit }, object: { id: string; item: ItemWrite }) {
      const result = await itemApi.update1(object.item, object.id);
      commit("doNothing", null);
      return result;
    },
    async createItem({ commit }, item: ItemWrite) {
      const result = await itemApi.createItem(item);
      commit("replaceItems", result);
      return result;
    },
    async deleteItems({ commit }, items: []) {
      const data = await itemApi.deleteByIds(items);
      return data;
    },
    async history({ commit }) {
      const result = await itemApi.getHistory();
      commit("setHisotry", result);
      return result;
    },
    async revert({ commit }, id) {
      const result = await itemApi.revertById(id);
      return result;
    }
  },
  modules: {}
});
